import { Typography } from "@mui/material";
import { useFormat } from "@sinch/core/hooks/format";
import React, { FC } from "react";

/**
 * Renders a cell with conditional styling based on whether it's a total row
 */
export const CurrencyCell: FC<{
  value: number | null;
  isTotalRow: boolean;
  defaultPositiveColor?: string;
  enlargeTotal?: boolean;
}> = ({ value, isTotalRow, defaultPositiveColor, enlargeTotal = false }) => {
  const { num } = useFormat();

if (value === null) {
    return '-';
  }

  return (
    <Typography
      sx={({ typography, palette }) => {
        const negativeNoZero = value !== 0 ? palette.error.main: undefined;
        return ({
        fontWeight: (isTotalRow ? typography.fontWeightBold : undefined) ?? null,
        fontSize: isTotalRow && enlargeTotal ? typography.pxToRem(15) : null,
        color: value > 0 ? (defaultPositiveColor ?? null) : negativeNoZero,
      });}}
    >
      {num.precisionCurrency(value)}
    </Typography>
  );
};
